import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./auth/KeycloakService";
import './index.css';
import App from './App';
import { handleTokenData } from './auth/TokenService';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function AppWithTokenGuard() {
  const [ready, setReady] = useState(false);

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{ onLoad: "login-required", checkLoginIframe: false }}
      onTokens={async (tokens) => {
        console.log("🕒 handleTokenData...");
        await handleTokenData(tokens.token!, tokens.refreshToken!);
        console.log("✅ Token handled");
        setReady(true);
      }}
      onEvent={(event, error) => {
        console.log("🔔 Evento Keycloak:", event);

        if (event === 'onAuthSuccess') console.log("✅ Autenticazione avvenuta");
        if (event === 'onAuthRefreshSuccess') console.log("🔁 Token aggiornato con successo");
        if (event === 'onAuthRefreshError') {
          console.warn("❌ Errore nel refresh, logout forzato");
          keycloak.logout();
        }
        if (event === 'onTokenExpired') console.log("⚠️ Token scaduto");
      }}
    >
      {ready ? <App /> : <div style={{ padding: "2rem", fontSize: "1.2rem" }}>🔐 Caricamento sessione in corso...</div>}
    </ReactKeycloakProvider>
  );
}

root.render(<AppWithTokenGuard />);
